import {useEffect, useState} from "react";
import {IConfigurationContext, IConfigurationContextState} from "./ConfigurationContext.interfaces";
import {AxiosConfig} from "apis/AxiosConfig/AxiosConfig";
import {StorageType, useCacheService} from "services/CacheService";
import {IConfiguration} from "Interfaces/IConfiguration";
import {ConfigurationApi} from "../../apis/configurationApi";

const defaultConfiguration: IConfigurationContextState = {
    loaded: false,
    data: {
        baseUrl: "",
        clientId: "",
        graphScopes: "",
        appInsightKey: "",
        accessScope: "",
    }
};

const cacheKey = "app_configuration";

export const useConfigurationContext = (): IConfigurationContext => {
    const [state, setState] = useState<IConfigurationContextState>(defaultConfiguration);
    const cacheService = useCacheService(StorageType.Session);

    useEffect(function onMount() {
        (async () => await initialize())();
    }, [])

    const initialize = async () => {
        const configuration = await getConfig();
        const apiBaseUrl = `https://${configuration.baseUrl}/api`;
        AxiosConfig.setAxiosInstanceApiBaseUrl(apiBaseUrl);
        setState((prevState): IConfigurationContextState => {
            if (!configuration) throw new Error("Invalid configuration");
            return {
                ...prevState,
                data: configuration,
                loaded: true,
            };
        });
    }

    const getConfig = async (): Promise<IConfiguration> => {
        return new Promise<IConfiguration>(async resolve => {
            let configuration: IConfiguration | null = cacheService.getItem<IConfiguration>("app_configuration");
            if (!configuration) {
                configuration = await ConfigurationApi.getConfiguration();
                if (!configuration) throw new Error("Can't get app configuration");
                cacheService.setItem(cacheKey, configuration);
                setTimeout(() => resolve(configuration!), 100);
            }
            return resolve(configuration);
        })
    }

    return state;
}

export const getConfiguration = (): IConfiguration | null => {
    if (!sessionStorage) return null;
    return JSON.parse(sessionStorage.getItem(cacheKey) ?? "null");
}